<template>
  <div class="create-post-drawer"
       v-if="drawer">
    <el-drawer :title="setTitlt"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="公司名称"
                        prop="enterpriseId">
            <el-select v-model="form.enterpriseId"
                       placeholder="请选择公司"
                       ref="companyName"
                       filterable
                       :disabled="disabled"
                       class="company">
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.shortName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划">
            <el-select filterable
                       v-model="form.projectId"
                       clearable
                       placeholder="请选择计划">
              <el-option v-for="item in projectList"
                         :key="item.id"
                         :label="item.projectName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位名称"
                        prop="positionName">
            <el-input v-model="form.positionName"
                      maxlength="20"
                      placeholder="请输入职位名称"></el-input>
          </el-form-item>

          <el-form-item label="职位类别"
                        prop="positionType">
            <el-select v-model="form.positionType"
                       placeholder="职位类别"
                       class="company">
              <el-option v-for="item in positionList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>

          </el-form-item>
          <!-- <el-form-item label="排序">
            <el-input-number v-model="form.sort"
                             :precision="0"></el-input-number>
          </el-form-item> -->
          <el-form-item label="薪资类型"
                        prop="remunerationType">
            <el-select v-model="form.remunerationType"
                       placeholder="请选择薪资类型"
                       clearable
                       @change="$set(form, 'remunerationLevel', '');$forceUpdate()">
              <el-option label="日薪"
                         :value="1"> </el-option>
              <el-option label="周薪"
                         :value="2"> </el-option>
              <el-option label="月薪"
                         :value="3"> </el-option>
              <el-option label="小时工资"
                         :value="4"> </el-option>
              <el-option label="计件工资"
                         :value="5"> </el-option>
              <el-option label="面议"
                         :value="6"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公共职位">
            <el-checkbox v-model="form.isPublic">是</el-checkbox>
          </el-form-item>
          <div>
            <el-form-item label="职位生效"
                          prop="dateTimeFrom">
              <el-date-picker v-model="form.dateTimeFrom"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="startDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>

            <!-- 职位结束日期（限制：必须大于开始日期） -->
            <el-form-item label="职位结束"
                          prop="dateTimeTo">
              <el-date-picker v-model="form.dateTimeTo"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="endDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>

            <el-form-item label="招聘人数">
              <el-input-number v-model="form.num"
                               @change="handleNumChange"
                               :min="1"
                               :max="9999"
                               label="描述文字"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="到期时间">
              <el-date-picker v-model="form.value1"
                              type="datetime"
                              placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="时薪范围"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 4">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入时薪范围"
                        maxlength="30"
                        style="width: 60%">
                <template slot="append">元/小时</template></el-input></el-form-item>
            <el-form-item label="日收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 1">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入日收入范围"
                        maxlength="30"
                        type="number"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="月收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 3">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入月收入范围"
                        maxlength="30"
                        type="number"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="周收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 2">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入周收入范围"
                        maxlength="30"
                        type="number"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="单件收入"
                          :prop="form.isRelease ?'remunerationLevel':''"
                          v-if="form.remunerationType == 5">
              <el-input v-model="form.remunerationLevel"
                        placeholder="请输入单件收入"
                        maxlength="10"
                        type="number"
                        style="width: 60%">
                <template slot="append">元</template></el-input></el-form-item>
            <el-form-item label="福利标签">
              <el-input id="input1"
                        v-model="form.label"
                        maxlength="30"
                        placeholder="如：包吃，包住，厂车等，多个标签用逗号隔开"></el-input>
            </el-form-item>

            <!-- <el-form-item label="招聘人数">
              <el-input-number v-model="form.welfareLabel"
                               @change="handleNumChange"
                               :min="1"
                               label="描述文字"></el-input-number>
            </el-form-item> -->

            <el-form-item label="性别要求">
              <el-select v-model="form.gender"
                         placeholder="请选择性别要求"
                         clearable>
                <el-option label="男"
                           value="男"> </el-option>
                <el-option label="女"
                           value="女"> </el-option>
                <el-option label="无要求"
                           value="无要求"> </el-option>
              </el-select>
              <!-- <el-input v-model="form.sex" maxlength="30"> </el-input> -->
            </el-form-item>
            <el-form-item label="年龄要求"
                          prop="age">
              <div style="width: 90%; display: inline-block">
                <input-number-range :precision="0"
                                    v-model="form.age"></input-number-range>
              </div>
              岁
            </el-form-item>
            <div style="overflow: hidden">

              <el-col :span="24">
                <el-form-item label="职位描述"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.jobDescribe"
                                    v-model="form.jobDescribe"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入职位描述"
                            v-model="form.jobDescribe">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="职位要求"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.jobRequirements"
                                    v-model="form.jobRequirements"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入职位要求"
                            v-model="form.jobRequirements">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="福利待遇"
                              class="form-item-block">
                  <vue-ueditor-wrap v-if="form.jobBenefits"
                                    v-model="form.jobBenefits"
                                    :config="myConfig"></vue-ueditor-wrap>
                  <el-input v-else
                            type="textarea"
                            :rows="2"
                            resize="none"
                            placeholder="请输入福利待遇"
                            v-model="form.jobBenefits">
                  </el-input>
                </el-form-item>
              </el-col>
            </div>
          </div>
        </el-form>
      </div>
      <div class="rightPadding"></div>
      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit('form')">保 存</el-button>
      </div>
    </el-drawer>
    <el-dialog title="新增职位类型"
               :visible.sync="addCategoryDrawerShow"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="500px"
               class="colleague-dialog"
               @close="resetForm">
      <el-form ref="CategoryForm"
               :model="CategoryForm"
               :rules="rules"
               label-width="80px">
        <el-form-item label="类别名称"
                      prop="name">
          <el-input v-model="CategoryForm.name"></el-input>
        </el-form-item>

        <el-form-item label="排序"
                      class="number-footer">
          <el-input-number v-model="CategoryForm.sort"
                           :precision="0"></el-input-number>
        </el-form-item>

        <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              addCategoryDrawerShow = false;
            }
          ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="addCategory('CategoryForm')">确 定</el-button>
      </span>
    </el-dialog>
    <jobMacting :visible="jobMactingVisible"
                @close="(jobMactingVisible = false), (items = [])"
                :posName="form.position"
                type="1"
                :industry="industry"
                @enter="enter"></jobMacting>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import InputNumberRange from "../../components/InputNumberRange.vue";
import jobMacting from "@/components/jobMatching";
import { employmentTypeList } from "@/utils/common"
export default {
  components: {
    VueUeditorWrap,
    InputNumberRange,
    jobMacting,
  },
  props: {
    users: Array,
    drawerShow: Boolean,
    postInfo: Object,
    operation: String,
    companyId: String,
    cityList: Array,
  },
  data () {
    let validateage = (rule, value, callback) => {
      if (value == undefined) {
        callback();
        return;
      }
      if (value[0] == null && value[1] == null) {
        callback();
      }
      if (!value[0] || !value[1]) {
        callback(new Error("请输入完整"));
      } else {
        callback();
      }
    };
    return {
      myConfig: {
        // 设置编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 280,
        // 初始容器宽度
        initialFrameWidth: "100%",

        // UEditor 是文件的存放路径，
        UEDITOR_HOME_URL: "/Ueditor/",
      },
      value: "",
      pushType: 3,
      CategoryForm: {},
      submitLoading: false,
      drawer: false,
      addCategoryDrawerShow: false,
      postStateList: [],
      salaryLevel: [],
      form: {
        state: 1,
        num: 1,
        participant: [],
        participantName: [],
        recruitingNum: 1,
        remunerationType: '',
        isPublic: true,
      },
      startDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择结束日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeTo) return false;

          // 转换结束日期为 Date 对象，清除时间部分
          const endDate = new Date(this.form.dateTimeTo);
          endDate.setHours(0, 0, 0, 0);

          // 禁用：结束日期及之后的所有日期（确保开始 < 结束）
          return date.getTime() >= endDate.getTime();
        }
      },
      // 结束日期选择器配置：禁用 <= 开始日期的日期
      endDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择开始日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeFrom) return false;

          // 转换开始日期为 Date 对象，清除时间部分
          const startDate = new Date(this.form.dateTimeFrom);
          startDate.setHours(0, 0, 0, 0);

          // 禁用：开始日期及之前的所有日期（确保结束 > 开始）
          return date.getTime() <= startDate.getTime();
        }
      },

      rules: {
        dateTimeFrom: [{ required: true, message: "请选择职位开始时间", trigger: "blur" }],

        name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
        enterpriseId: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        positionName: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
        ],
        wages1: [{ required: true, message: "请输入工厂结算", trigger: "blur" }],
        wages2: [{ required: true, message: "请输入公司报价", trigger: "blur" }],
        wages3: [{ required: true, message: "请输入员工工资", trigger: "blur" }],
        num: [{ required: true, message: "请输入招聘人数", trigger: "blur" }],
        remunerationLevel: [
          { required: true, message: "请输入工资范围", trigger: "blur" },
        ],
        remunerationType: [
          {
            required: true,
            message: "请选择薪资类型",
            trigger: ["blur", "change"],
          },
        ],
        maxNum: [
          {
            required: true,
            message: "请输入工资范围",
            trigger: ["blur"],
          },
        ],
        positionType: [
          {
            required: true,
            message: "请选择职位类型",
            trigger: ["blur", "change"],
          },
        ],
        HourlyWage: [
          { required: true, message: "请输入时薪范围", trigger: "blur" },
        ],
        age: [{ validator: validateage, trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别要求", trigger: "blur" }],
        desc: [
          {
            required: true,
            message: "请输入职位描述",
            trigger: ["blur", "change"],
          },
        ],
        request: [
          {
            required: true,
            message: "请输入职位要求",
            trigger: ["blur", "change"],
          },
        ],
        weal: [
          {
            required: true,
            message: "请输入福利待遇",
            trigger: ["blur", "change"],
          },
        ],
      },
      jobNatureList: [],
      demandTypeList: [],
      postId: "",
      disabled: false,
      companyList: [],
      workExperience: [],
      positionList: employmentTypeList,
      jobMactingVisible: false,
      industry: "",
      projectList: [],
    };
  },
  mounted () { },
  computed: {
    setTitlt () {
      return this.operation === "edit" ? "修改职位信息" : "新增职位";
    },
  },
  methods: {
    handleDateChange () {
      const { dateTimeFrom, dateTimeTo } = this.form;
      // 两个日期都已选择时才校验
      if (dateTimeFrom && dateTimeTo) {
        const start = new Date(dateTimeFrom);
        const end = new Date(dateTimeTo);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        // 如果开始 >= 结束，清空后选择的那个日期（谁后变就清空谁）
        // 这里简化逻辑：直接清空结束日期（也可根据业务调整为清空开始日期）
        if (start >= end) {
          this.form.dateTimeTo = '';
          // 若想清空开始日期，可改为：this.form.dateTimeFrom = '';
        }
      }
    },
    //薪资类型的判断
    remunerationTypeJudge () {
      if (this.form.remunerationType) {
        switch (this.form.remunerationType) {
          case 1:
            return '元/日';
          case 2:
            return '元/周';
          case 3:
            return '元/月';
          case 4:
            return '元/时';
          case 5:
            return '元/件';
          default:
            return '元';
        }
      }
      else {
        return '元';
      }
    },
    // 同步标准职位
    enter (value, name) {
      this.form.standardName = value.standardName;
      this.form.standardRank = value.standardRank;
      this.form.occupationCode = value.occupationCode;
      this.$set(this.form, "position", name);
      // console.log(value);
    },
    addCategory (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          let sendData = {
            name: this.CategoryForm.name,
            sort: this.CategoryForm.sort,
          };
          this.$api.posts
            .PositionTypeEdit(JSON.stringify(sendData))
            .then((res) => {
              if (res.error == false) {
                // this.getPositionList();
                this.addCategoryDrawerShow = false;
                this.$message.success("保存成功");
                this.submitLoading = false;
              }
            });
        } else {
          //就像用户提示发生错误的消息
        }
      });
    },
    handleChange (value) { },
    colseDrawer () {
      this.$refs["form"].resetFields();
      this.$emit("colseDrawer");
    },
    handleNumChange (val) {
      this.form.recruitingNum = val;
      console.log(this.form.recr);
    },
    resetForm () {
      this.CategoryForm = {};
      this.$refs.CategoryForm.clearValidate();
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        this.submitLoading = true;
        let sendData = this.form;
        sendData.enterpriseShortName = this.$refs.companyName.selected.label;
        sendData.remunerationType = String(this.form.remunerationType);
        sendData.releaseType = String(this.form.releaseType);;
        sendData.welfareLabel = this.form.label && this.form.label.replace(/\s+/g, "");
        sendData.age = this.form.age == ',' ? '' : this.form.age && this.form.age.toString();
        if (this.operation === "edit") {
          sendData.id = this.postId;
        }
        this.$api.PositionInfo[this.operation == 'edit' ? 'Modify' : 'Create'](sendData).then((res) => {
          this.colseDrawer();
          this.$refs[formName].resetFields();
          if (res.error === false) {
            this.$message.success("保存职位信息成功");
            this.$emit("refreshData");
          } else {
            this.$message.error("保存职位信息失败");
          }
          this.submitLoading = false;
          this.postId = "";
        });
      });
    },
    turnNum (nums) {
      if (nums == ",") {
        return;
      }
      return nums.map(Number);
    },
    fillFormData (obj) {

      this.postId = obj.id;
      this.$set(this, 'form', obj)
      this.$set(this.form, "companyid", obj.customerId);
      this.$set(this.form, "position", obj.positionName);
      this.$set(this.form, "department", obj.department);
      this.$set(this.form, "num", obj.recruitingNum);
      this.$set(this.form, "startTime", obj.putForwardTime);
      this.$set(this.form, "endTime", obj.inductionTIme);
      this.$set(this.form, "jobNature", obj.jobCategory);
      this.$set(this.form, "demandType", obj.demandType);
      this.$set(this.form, "sex", obj.sex);
      this.$set(this.form, "projectId", obj.projectId);
      this.$set(this.form, "positionTypeId", obj.positionTypeId);
      this.$set(this.form, "city", obj.workCity && obj.workCity.split(","));
      this.$set(this.form, "isUrgency", obj.CriticalSituation);
      this.$set(this.form, "principalMan", obj.PrincipalId);
      this.$set(this.form, "age", obj.age && this.turnNum(obj.age.split(",")));
      this.$set(this.form, "HourlyWage", obj.hourlyWage);
      this.$set(this.form, "remunerationLevel", obj.remunerationLevel);
      this.$set(this.form, "remunerationType", Number(obj.remunerationType));
      this.$set(this.form, "weal", obj.weal);
      this.$set(this.form, "request", obj.request);
      this.$set(this.form, "sort", obj.sort);
      this.$set(this.form, "state", obj.state);
      this.$set(this.form, "label", obj.welfareLabel);
      this.$set(this.form, "desc", obj.jobDescribe);
      this.$set(this.form, "remark", obj.Remark);
      this.$set(this.form, "askForEducation", obj.AskForEducation);
      this.$set(this.form, "standardName", obj.standardName);
      this.$set(this.form, "standardRank", obj.standardRank);
      this.$set(this.form, "releaseType", obj.releaseType);
      this.$set(this.form, "isRelease", obj.isRelease);

    },

    //获取公司列表
    getCompanyList () {
      let sendData = {
        pageSize: -1,
      }
      this.$api.EnterpriseInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
          // if (this.companyId) {
          // }
        }
      });
    },
    getProjectList () {
      let sendData = {
        pageSize: -1,
      }
      this.$api.ProjectInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.projectList = res.data;
        }
      });
    },
    // 获取职位类型
    getPositionList () {
      let sendData = {
        pageIndex: 1,
        pageSize: 1000,
      };
      this.$api.posts.PositionTypePage(sendData).then((res) => {

        if (res.error === false) {
          this.positionList = res.data.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {
      this.drawer = val;
      if (val) {
        this.getCompanyList();
        // this.getPositionList();
        this.getProjectList();
      }
      if (this.drawer == false) {
        this.postId = "";
        if (val) {
          this.$nextTick(() => {
            this.$refs["form"].clearValidate();
          });
          return;
        }
      }
      console.log(this.operation);
      if (this.operation == "edit" && this.drawer) {
        this.fillFormData(this.postInfo);
      }
      if (this.operation == "add") {
        this.$set(this.form, "age", [null, null]);
        this.form = {
          state: 1,
          num: 1,
          participant: [],
          participantName: [],
          recruitingNum: 1,
          remunerationType: '',
          isPublic: true,
        }
        this.$forceUpdate();

      }
      if (this.companyId) {
        this.$set(this.form, "companyid", this.companyId);

        this.disabled = true;
      }
    },
  },
};
</script>

<style lang="less">
#input1 {
  width: 300px;
}
.create-post-drawer {
  .el-drawer {
    width: 78% !important;
    min-width: 1150px;

    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 50px 60px 50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;

    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 56%;
      }

      .el-select {
        width: 100%;
      }
    }
    .standardName {
      .el-form-item__content {
        width: auto;
      }
    }
    .minNum {
      .el-form-item__content {
        width: 50% !important;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(85% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
    .foreign {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #dcdfe6;
    }
  }
  .tip {
    font-size: 12px;
    color: #909399;
  }
  .priceSetting {
    .el-form-item__content {
      width: 70% !important;
    }

    .bpttpmTip {
      display: flex;
      p {
        line-height: 1.6;
      }
    }
  }
  .el-divider__text.is-center {
    color: #66b1ff;
  }
  .block {
    display: block;
    .el-form-item__content {
      width: calc(100% - 80px);
    }
  }
}
// .post-form {
//   .el-input {
//     min-width: 280px;
//     max-width: 350px;
//   }
//   .el-input-number {
//     .el-input {
//       min-width: auto;
//     }
//   }
// }
.submit-bar {
  position: absolute;
  z-index: 99999999;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  .el-button {
    padding: 8px 20px;
  }
}
</style>
